import { PaymentMethodType } from '@nemuru-eng/checkout-js';

import { ICON_NAMES } from '@/config/config';

export const getCardHeaderParamsBySinglePaymentType = (
  paymentMethodType: PaymentMethodType.A2A_PAYMENT | PaymentMethodType.CARD_PAYMENT,
) => {
  switch (paymentMethodType) {
    case PaymentMethodType.CARD_PAYMENT:
      return {
        title: `${PaymentMethodType.CARD_PAYMENT}_SHORT`,
        surtitle: 'SINGLE_PAYMENT',
        iconName: ICON_NAMES.CARD_PAYMENT,
      };
    case PaymentMethodType.A2A_PAYMENT:
      return {
        title: `${PaymentMethodType.A2A_PAYMENT}_SHORT`,
        surtitle: 'SINGLE_PAYMENT',
        iconName: ICON_NAMES.A2A_PAYMENT,
      };
    default:
      return null;
  }
};
